import { gql } from "@apollo/client";

export default gql`
  query getMobileAppVersion($input: GetMobileAppVersionInput!){
    getMobileAppVersion(input: $input){
        success
        data{
            platform
            currentVersion
            latestVersion
            minSupportedVersion
            updateType
            storeUrl
            releaseNotes{
                tr{
                    title
                    body
                }
                en{
                    title
                    body
                }
                ar{
                    title
                    body
                }
            }
        }
        error
        message
    }
}
`
